module.exports = __webpack_public_path__ + "icon1.svg?6a17ed1fbc5cfa93b49cbf1886957195";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_svg/icon1.svg
// module id = 80
// module chunks = 0